import { MatIconModule } from '@angular/material/icon';
import { MatInputModule as MatInputModule} from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { ColorChromeModule} from 'ngx-color/chrome';
import { ActionTabletModule, ActionTabletRegistryService, AppClientResourcesModule } from '@sdbn/common';
import { ActionTabletLprFailuresComponent } from './action-tablet-lpr-failures.component';
import { CommonFormattingModule, CommonLayoutModule, CommonTranslationModule, CommonUIButtonsModule, CommonUIDialogModule, CommonUIModule, CommonUIFieldsModule } from '@sdbn/common';
import { ActionTabletLprFailureDetailsComponent } from './action-tablet-lpr-failure-details/action-tablet-lpr-failure-details.component';


@NgModule({
  declarations: [
    ActionTabletLprFailuresComponent,
    ActionTabletLprFailureDetailsComponent
  ],
  imports: [
    CommonModule,
    OverlayModule,
    ColorChromeModule,
    FormsModule,
    MatInputModule,
    MatIconModule,
    ActionTabletModule,
    CommonLayoutModule,
    CommonUIModule,
    AppClientResourcesModule,
    CommonUIDialogModule,
    CommonUIButtonsModule,
    CommonTranslationModule,
    CommonUIFieldsModule,
    CommonFormattingModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    ActionTabletLprFailuresComponent
  ]
})
export class ActionTabletLPRFailuresModule {

  constructor(actionTabletRegistryService: ActionTabletRegistryService) {

    actionTabletRegistryService.registerType('lpr_failures', ActionTabletLprFailuresComponent);

  }

}
